module.exports = require('./lib');


//////////////////
// WEBPACK FOOTER
// ./~/react-cookie-banner/index.js
// module id = 291
// module chunks = 0